import { BottomNavigation, BottomNavigationAction, Box, useTheme, alpha } from "@mui/material";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Paper from '@mui/material/Paper';
import HomeIcon from '@mui/icons-material/Home';
import BiotechIcon from '@mui/icons-material/Biotech';
import PersonIcon from '@mui/icons-material/Person';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import TimelineIcon from '@mui/icons-material/Timeline';

export default function Footer() {
  const location = useLocation();
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  const [value, setValue] = useState(location.pathname);
  const [mounted, setMounted] = useState(false);

  // Update the active tab based on current location
  useEffect(() => {
    setValue(location.pathname);
  }, [location]);

  // Add mount animation
  useEffect(() => {
    setMounted(true);
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <Paper 
      sx={{ 
        position: 'fixed', 
        bottom: 0, 
        left: 0, 
        right: 0,
        transform: mounted ? 'translateY(0)' : 'translateY(100%)',
        transition: 'transform 0.3s ease-in-out',
        borderRadius: '16px 16px 0 0',
        overflow: 'hidden',
        boxShadow: isDarkMode 
          ? '0 -4px 20px rgba(0,0,0,0.3)' 
          : '0 -4px 20px rgba(0,0,0,0.1)',
        zIndex: 1000,
        mx: { sm: 2, md: 4 },
        width: { sm: 'auto' }
      }} 
      elevation={4}
    >
      <BottomNavigation  
        value={value} 
        onChange={handleChange}
        sx={{
          height: 70,
          background: isDarkMode 
            ? 'linear-gradient(180deg, rgba(35,35,40,0.95) 0%, rgba(28,28,33,0.98) 100%)' 
            : 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(250,250,255,0.98) 100%)',
          backdropFilter: 'blur(10px)',
          '& .MuiBottomNavigationAction-root': {
            color: isDarkMode ? alpha(theme.palette.common.white, 0.5) : alpha(theme.palette.common.black, 0.5),
            '&.Mui-selected': {
              color: theme.palette.primary.main,
            },
            transition: 'all 0.2s ease'
          },
        }}
      >
        <BottomNavigationAction
          label="Home"
          value="/"
          component={Link}
          icon={<HomeIcon sx={{ 
            fontSize: '1.6rem',
            transform: value === '/' ? 'translateY(-4px)' : 'none',
            transition: 'transform 0.2s ease'
          }} />}
          to="/"
          sx={{
            '&.Mui-selected': {
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 'bold',
                opacity: 1,
              }
            }
          }}
        />
        {/* <BottomNavigationAction
          label="Quick Scan"
          value="/ChatDomain"
          component={Link}
          icon={<BiotechIcon sx={{ 
            fontSize: '1.6rem',
            transform: value === '/ChatDomain' ? 'translateY(-4px)' : 'none',
            transition: 'transform 0.2s ease'
          }} />}
          to="/ChatDomain"
          sx={{
            '&.Mui-selected': {
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 'bold',
                opacity: 1,
              }
            }
          }}
        /> */}
        <BottomNavigationAction
          label="Patients"
          value="/patients"
          component={Link}
          icon={<PersonIcon sx={{ 
            fontSize: '1.6rem',
            transform: value === '/patients' ? 'translateY(-4px)' : 'none',
            transition: 'transform 0.2s ease'
          }} />}
          to="/patients"
          sx={{
            '&.Mui-selected': {
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 'bold',
                opacity: 1,
              }
            }
          }}
        />
        <BottomNavigationAction
          label="Onboarding"
          value="/DoctorOnboarding"
          to="/DoctorOnboarding"
          component={Link}
          icon={<SettingsSuggestIcon sx={{ 
            fontSize: '1.6rem',
            transform: value === '/DoctorOnboarding' ? 'translateY(-4px)' : 'none',
            transition: 'transform 0.2s ease'
          }} />}
          sx={{
            '&.Mui-selected': {
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 'bold',
                opacity: 1,
              }
            }
          }}
        />
        <BottomNavigationAction 
          label="Analytics"
          value="/EpidemiologyAnalytics"
          to="/EpidemiologyAnalytics"
          component={Link}
          icon={<TimelineIcon sx={{ 
            fontSize: '1.6rem',
            transform: value === '/EpidemiologyAnalytics' ? 'translateY(-4px)' : 'none',
            transition: 'transform 0.2s ease'
          }} />}
          sx={{
            '&.Mui-selected': {
              '& .MuiBottomNavigationAction-label': {
                fontSize: '0.75rem',
                fontWeight: 'bold',
                opacity: 1,
              }
            }
          }}
        />
      </BottomNavigation>
    </Paper>
  );
}

